// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.DeviceSettings in deviceSettings/deviceSettings.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Target device main settings
 *
 * @property software update type
 * @property enable/disable Vreo backoffice reporting (Device Hub)
 */
public class DeviceSettings(
  @field:WireField(
    tag = 1,
    adapter = "vreo.volt.protocol.UpdateReleaseType#ADAPTER",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "updateType",
    schemaIndex = 0,
  )
  public val update_type: UpdateReleaseType = UpdateReleaseType.ALPHA,
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enableDeviceHubReporting",
    schemaIndex = 1,
  )
  public val enable_device_hub_reporting: Boolean = false,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<DeviceSettings, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is DeviceSettings) return false
    if (unknownFields != other.unknownFields) return false
    if (update_type != other.update_type) return false
    if (enable_device_hub_reporting != other.enable_device_hub_reporting) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + update_type.hashCode()
      result = result * 37 + enable_device_hub_reporting.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """update_type=$update_type"""
    result += """enable_device_hub_reporting=$enable_device_hub_reporting"""
    return result.joinToString(prefix = "DeviceSettings{", separator = ", ", postfix = "}")
  }

  public fun copy(
    update_type: UpdateReleaseType = this.update_type,
    enable_device_hub_reporting: Boolean = this.enable_device_hub_reporting,
    unknownFields: ByteString = this.unknownFields,
  ): DeviceSettings = DeviceSettings(update_type, enable_device_hub_reporting, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<DeviceSettings> = object : ProtoAdapter<DeviceSettings>(
      FieldEncoding.LENGTH_DELIMITED, 
      DeviceSettings::class, 
      "type.googleapis.com/vreo.volt.protocol.DeviceSettings", 
      PROTO_3, 
      null, 
      "deviceSettings/deviceSettings.proto"
    ) {
      override fun encodedSize(`value`: DeviceSettings): Int {
        var size = value.unknownFields.size
        if (value.update_type != vreo.volt.protocol.UpdateReleaseType.ALPHA) {
          size += UpdateReleaseType.ADAPTER.encodedSizeWithTag(1, value.update_type)
        }
        if (value.enable_device_hub_reporting != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(2, value.enable_device_hub_reporting)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: DeviceSettings) {
        if (value.update_type != vreo.volt.protocol.UpdateReleaseType.ALPHA) {
          UpdateReleaseType.ADAPTER.encodeWithTag(writer, 1, value.update_type)
        }
        if (value.enable_device_hub_reporting != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 2, value.enable_device_hub_reporting)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: DeviceSettings) {
        writer.writeBytes(value.unknownFields)
        if (value.enable_device_hub_reporting != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 2, value.enable_device_hub_reporting)
        }
        if (value.update_type != vreo.volt.protocol.UpdateReleaseType.ALPHA) {
          UpdateReleaseType.ADAPTER.encodeWithTag(writer, 1, value.update_type)
        }
      }

      override fun decode(reader: ProtoReader): DeviceSettings {
        var update_type: UpdateReleaseType = UpdateReleaseType.ALPHA
        var enable_device_hub_reporting: Boolean = false
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> try {
              update_type = UpdateReleaseType.ADAPTER.decode(reader)
            } catch (e: ProtoAdapter.EnumConstantNotFoundException) {
              reader.addUnknownField(tag, FieldEncoding.VARINT, e.value.toLong())
            }
            2 -> enable_device_hub_reporting = ProtoAdapter.BOOL.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return DeviceSettings(
          update_type = update_type,
          enable_device_hub_reporting = enable_device_hub_reporting,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: DeviceSettings): DeviceSettings = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
